module.exports = __webpack_public_path__ + "media/images/page/top/top_bg_04-92cd84fcf0f20af278cc3cfaec98f405.png";